import axios from 'axios';

const isFileLike = (value) => value instanceof File || value instanceof Blob;

const normalizeFormDataValue = (value) => {
  if (value instanceof Date) {
    return value.toISOString();
  }

  return value;
};

const buildCustomersPayload = (payload = {}) => {
  if (payload instanceof FormData) {
    return payload;
  }

  if (!isFileLike(payload?.logo)) {
    return payload;
  }

  const formData = new FormData();

  Object.keys(payload || {}).forEach((key) => {
    const value = payload[key];

    if (value === undefined || value === null) {
      return;
    }

    formData.append(key, normalizeFormDataValue(value));
  });

  return formData;
};

export default {
  index: (params = {}, config = {}) => axios.get('customers', { params, ...config }),
  selectors: (params = {}, config = {}) => axios.get('customers/selectors', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('customers/metrics', { params, ...config }),
  detailMetrics: (customerId) => axios.get(`customers/${customerId}/metrics`),
  detailOverview: (customerId) => axios.get(`customers/${customerId}/overview`),
  activity: (customerId, params = {}, config = {}) => axios.get(`customers/${customerId}/activity`, { params, ...config }),
  store: (payload = {}, config = {}) => {
    const requestPayload = buildCustomersPayload(payload);
    return axios.post('customers', requestPayload, config);
  },
  storeWithContributor: (payload = {}) => axios.post('customers/with-contributor', payload),
  show: (customerId) => axios.get(`customers/${customerId}`),
  update: (customerId, payload = {}, config = {}) => {
    const requestPayload = buildCustomersPayload(payload);

    if (requestPayload instanceof FormData) {
      requestPayload.set('_method', 'PUT');
      return axios.post(`customers/${customerId}`, requestPayload, config);
    }

    return axios.put(`customers/${customerId}`, requestPayload, config);
  },
  updateVisibility: (customerId, payload = {}, config = {}) => axios.put(`customers/${customerId}/visibility`, payload, config),
  merge: (customerId, payload = {}, config = {}) => axios.put(`customers/${customerId}/merge`, payload, config),
  importSections: (config = {}) => axios.get('customers/imports/sections', config),
  importTemplate: (sectionKey, config = {}) => axios.get(`customers/imports/template/${sectionKey}`, {
    responseType: 'blob',
    ...config,
  }),
  importValidate: (payload, config = {}) => axios.post('customers/imports/validate', payload, config),
  importExecute: (batchId, payload = {}, config = {}) => axios.post(`customers/imports/${batchId}/execute`, payload, config),
  exportColumns: (config = {}) => axios.get('customers/exports/columns', config),
  exportFormats: (config = {}) => axios.get('customers/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('customers/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`customers/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`customers/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('customers/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  toggleStatus: (customerId, payload = {}) => axios.put(`customers/${customerId}/status`, payload),
  syncFinancials: (payload = {}, config = {}) => axios.post('customers/sync-financials', payload, config),
  delete: (customerId) => axios.delete(`customers/${customerId}`),
  personsIndex: (customerId) => axios.get(`customers/${customerId}/persons`),
  personsStore: (customerId, payload = {}) => axios.post(`customers/${customerId}/persons`, payload),
  personsUpdate: (customerId, personId, payload = {}) => axios.put(`customers/${customerId}/persons/${personId}`, payload),
  personsDelete: (customerId, personId) => axios.delete(`customers/${customerId}/persons/${personId}`),
  contributorsIndex: (customerId) => axios.get(`customers/${customerId}/contributors`),
  contributorsStore: (customerId, payload = {}) => axios.post(`customers/${customerId}/contributors`, payload),
  contributorsUpdate: (customerId, contributorId, payload = {}) => axios.put(`customers/${customerId}/contributors/${contributorId}`, payload),
  contributorsDelete: (customerId, contributorId) => axios.delete(`customers/${customerId}/contributors/${contributorId}`),
  recordsIndex: (customerId, params = {}, config = {}) => axios.get(`customers/${customerId}/records`, { params, ...config }),
  recordsStore: (customerId, payload = {}) => axios.post(`customers/${customerId}/records`, payload),
  recordsUpdate: (customerId, recordId, payload = {}) => axios.put(`customers/${customerId}/records/${recordId}`, payload),
  recordsDelete: (customerId, recordId) => axios.delete(`customers/${customerId}/records/${recordId}`),
  documentsIndex: (customerId, params = {}, config = {}) => axios.get(`customers/${customerId}/documents`, { params, ...config }),
  documentsStore: (customerId, payload = {}, config = {}) => axios.post(`customers/${customerId}/documents`, payload, config),
  documentsUpdate: (customerId, documentId, payload = {}, config = {}) => axios.put(`customers/${customerId}/documents/${documentId}`, payload, config),
  documentsDelete: (customerId, documentId) => axios.delete(`customers/${customerId}/documents/${documentId}`),
  documentsDownloadAll: (customerId, params = {}, config = {}) => axios.get(
    `customers/${customerId}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    }
  ),
  documentsDownloadLegalFile: (customerId, params = {}, config = {}) => axios.get(
    `customers/${customerId}/documents/download-legal-file`,
    {
      params,
      responseType: 'blob',
      ...config,
    }
  ),
};
